import { render, staticRenderFns } from "./GoodsSync.vue?vue&type=template&id=076b05f2&scoped=true&"
import script from "./GoodsSync.vue?vue&type=script&lang=js&"
export * from "./GoodsSync.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSync.vue?vue&type=style&index=0&id=076b05f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076b05f2",
  null
  
)

export default component.exports